import { motion } from "framer-motion"
import React from "react"
import styled from "styled-components"

const slideConf = {
  enter: {
    position: "relative",
    opacity: 1,
    // x: 0,
    transition: { duration: 0.15 },
  },
  exit: {
    position: "absolute",
    // x: "50%",
    opacity: 0,
    transition: { duration: 0.15 },
    transtitionEnd: {
      position: "relative",
    },
  },
}

export const MainContainer = styled(motion.div).attrs(() => ({
  initial: "hidden",
  transition: {
    type: "linear",
  },
  variants: {
    hidden: {
      position: "absolute",
      opacity: 0,
      transition: { duration: 0.3 },
      transitionEnd: {
        position: "absolute",
      },
    },
    show: {
      position: "relative",
      opacity: 1,
      transition: { duration: 0.3 },
      transitionEnd: {
        position: "relative",
      },
    },
  },
}))`
  background-color: white;
`

export const SlideContainer = styled(motion.div).attrs(() => ({
  animate: "enter",
  exit: "exit",
  initial: "exit",
  transition: {
    type: "linear",
  },
  variants: slideConf,
}))`
  background: white;
  height: 100%;
`
